import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import GenericPublicPageWrapper from "../../../components/GenericPublicPageWrapper/GenericPublicPageWrapper";
import OrganizationCreateFrom from "./components/OrganizationCreateFrom/OrganizationCreateFrom";
import Forbidden from "../../staticPages/Forbidden/Forbidden";
import PublicPageCard from "../components/PublicPageCard";

const NonLoggedInCreateOrganization = () => {
    const [isOrgCreated, setIsOrgCreated] = useState(false);
    const [searchParams] = useSearchParams();
    const productParam = searchParams.get("product");

    const handleOrgCreated = (value: boolean) => {
        setIsOrgCreated(value);
    };

    const SuccessfulRegisteredOrg = (
        <PublicPageCard>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                <FormattedMessage
                    id="non-logged.message.create-organization-check-email"
                    defaultMessage="Your System Administrator should check their {br} email!"
                    values={{ br: <br key="check-email-br" /> }}
                />
            </Typography>
            <Typography sx={{ fontSize: "1rem" }}>
                <FormattedMessage
                    id="non-logged.message.create-organization-email-link"
                    defaultMessage="They will have a link to set their password. After doing so,{br} they can log in and start using 1health!"
                    values={{ br: <br key="email-link-br" /> }}
                />
            </Typography>
        </PublicPageCard>
    );
    const RightSide = !isOrgCreated ? <OrganizationCreateFrom createOrg={handleOrgCreated} /> : SuccessfulRegisteredOrg;
    if (!productParam) {
        return <Forbidden />;
    }

    return (
        /* NG-8572: the branding panel is gone from every public page. */
        <GenericPublicPageWrapper isSubdomain={false} right={RightSide} />
    );
};
export default NonLoggedInCreateOrganization;
